<template>
    <Splide
        v-if="content.length"
        :options="splideOptions">
        <SplideSlide
            v-for="i in content"
            :key="i.id">
            <article
                class="tw-relative tw-mx-auto tw-aspect-square tw-overflow-hidden tw-rounded-3xl tw-px-6 tw-py-3 max-md:tw-max-w-xs md:tw-aspect-[3/2] sm:xl:tw-aspect-[2/1] 3xl:tw-px-14 3xl:tw-py-10">
                <img
                    alt=""
                    class="tw-absolute tw-inset-0 tw-z-[1] tw-aspect-square tw-w-full tw-object-cover tw-object-center md:tw-aspect-[3/2] sm:xl:tw-aspect-[2/1]"
                    :src="useMedia(i.image).medium" />
                <div class="tw-relative tw-z-[2] tw-flex tw-h-full tw-flex-col">
                    <h4
                        v-if="i.title"
                        class="tw-mt-3 tw-text-sm 3xl:tw-text-base"
                        v-html="i.title"></h4>
                    <div
                        v-if="i.text"
                        class="tw-mt-2 tw-text-lg tw-font-bold 3xl:tw-text-2xl"
                        v-html="i.text"></div>
                    <v-btn
                        v-if="i.knowMoreUrl"
                        class="tw-mt-auto tw-h-12 tw-w-40 tw-bg-blue-900 tw-bg-opacity-90"
                        :class="{
                            'knowMoreUrl': isSafari
                        }"
                        elevation="0"
                        rounded="pill"
                        v-bind="urlProps(i.knowMoreUrl)">
                        <span class="tw-mr-1 tw-text-xs tw-text-white xl:tw-text-sm">Saiba mais</span>
                        <v-icon class="tw-text-white xl:tw-text-xl">mdi-arrow-top-right</v-icon>
                    </v-btn>
                </div>
            </article>
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import { useMedia } from '../composables/useMedia';
    import { urlProps } from '@/composables/urlProps';

    const props = defineProps<{
        content: any[];
    }>();

    const splideOptions = ref({
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '4rem',
        pagination: false,
        arrows: props.content.length > 2,
        rewind: true,
        autoplay: props.content.length > 2,
        interval: 2000,
        breakpoints: {
            1200: {
                perPage: 2,
                gap: '1rem',
            },
            768: {
                perPage: 1,
                arrows: props.content.length > 1,
                autoplay: props.content.length > 1,
                gap: '1rem',
            },
        },
    });

    const isSafari = computed(() => {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes("macintosh") || ua.includes("iphone") || ua.includes("ipad");
    })
</script>

<style>

    .knowMoreUrl {
        margin-bottom: 1.5rem;
    }

</style>
